import { isPast } from 'date-fns';

function isEnabled({ publishedAt }: { publishedAt?: string }) {
  return publishedAt && isPast(new Date(publishedAt));
}

export { isEnabled };
